import React, { Fragment } from 'react';
import { TooltipWrapper } from '../../blocks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faInfoCircle, faSearchPlus } from '@fortawesome/free-solid-svg-icons';
import format from 'date-fns/format';
import { Button, PopoverBody, UncontrolledPopover } from 'reactstrap';
import { UrlEnum } from '../../../shared';
import { ProgramRequestsTable } from './admin/program-requests-table';
import { ProgramRequestsInstitutionTable } from "./institution/program-requests-table-institution";
export const DeniedTab = ({ data }) => {
    return (
        <div
            className="tab-pane fade show active"
            id="denied"
            role="tabpanel"
            aria-labelledby="denied-tab"
        >
            <div className="card">
                <div className="table-responsive">
                    {data && data[0] && data[0].isAdmin && <ProgramRequestsTable
                      tableData={data}
                    />}
                    {data && data[0] && !data[0].isAdmin && <ProgramRequestsInstitutionTable
                      tableData={data}
                    />}
                </div>
            </div>
        </div>
    );
};
